import clsx from 'clsx';
import type { ReactNode } from 'react';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={clsx('animate-pulse rounded-md bg-white/10', className)}
      aria-hidden
    />
  );
}

interface StateCardProps {
  icon: ReactNode;
  title: string;
  message: string;
  action?: ReactNode;
  className?: string;
}

export function StateCard({ icon, title, message, action, className }: StateCardProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-3 p-8 text-center',
        className,
      )}
    >
      <div className="text-accent-400/80">{icon}</div>
      <h3 className="text-sm font-semibold text-slate-200">{title}</h3>
      <p className="max-w-xs text-xs text-slate-400">{message}</p>
      {action}
    </div>
  );
}
